import { Factory } from "@/data/dao/Factory";
import { LogDao } from "@/data/dao/service/LogDao";
import { SystemDao } from "@/data/dao/service/SystemDao";
import { LogLevel } from "@/data/model/Enums";
import type { ILog } from "@/data/model/Log";
import { DateTime } from "@/data/util/DateTime";

import { i18n } from "@/portal/Trans";
import { DataTable, type IDataTableConfig } from "@/portal/elements/DataTable";

export class SystemController {
    private $element: JQuery;

    private systemDao: SystemDao;
    private logDao: LogDao;

    private logTable?: DataTable<ILog>;

    constructor(element: JQuery) {
        this.$element = element;

        this.systemDao = Factory.getInstance<SystemDao>(SystemDao);
        this.logDao = Factory.getInstance<LogDao>(LogDao);

        this.initLogTable();
    }

    private initLogTable() {
        const tableConfig: IDataTableConfig<ILog> = {
            columnMapping: [
                {
                    name: i18n("system.fields.time"),
                    property: "created",
                    styles: { width: "20%" },
                    formatter: (m, p) => DateTime.toDateString(p) + " um " + DateTime.toTimeString(p),
                },
                {
                    name: i18n("system.fields.level"),
                    property: "level",
                    styles: { width: "15%" },
                    formatter: (m, p) => i18n("enums.LogLevel." + LogLevel[p]),
                },
                {
                    name: i18n("system.fields.title"),
                    property: "title",
                    styles: { width: "15%" },
                },
                {
                    name: i18n("system.fields.message"),
                    property: "message",
                    styles: { width: "50%" },
                },
            ],
            defaultSortProperty: "created",
            rowsPerPage: 10,
            defaultSortAsc: false,
        };

        this.logTable = new DataTable<ILog>(
            this.$element.find("#logtable > .kt-portlet__body > .kt-datatable"),
            this.logDao,
            tableConfig
        );
        this.$element.find("#logtable #clearlogsbtn").click((e) => {
            e.preventDefault();
            this.logDao.clearLogs().then(() => {
                this.logTable!.loadData();
            });
        });
    }
}
